import { Component, Input } from '@angular/core'
import { WatchListComponent } from '@shared/components/trading/watch-list/watch-list.component'
import { WidgetInterface } from '@modules/widgets-module/interfaces/widget.interface'
import { WatchListSettingsInterface } from '@shared/components/trading/widgets/watch-list-widget/core/interfaces/watch-list-settings.interface'

@Component({
	selector: 'app-watch-list-widget',
	templateUrl: './watch-list-widget.component.html',
	imports: [WatchListComponent],
	styleUrl: './watch-list-widget.component.scss',
})
export class WatchListWidgetComponent {
	@Input() widget: WidgetInterface<WatchListSettingsInterface> | null = null
}
